// Helper function to format file size
const formatFileSize = (sizeInBytes) => {
    if (sizeInBytes === 0) return "0 Bytes";
    
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const num = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    
    return `${parseFloat((sizeInBytes / 1024 ** num).toFixed(2))} ${sizes[num]}`;
};

export default formatFileSize;
